module.exports = __webpack_public_path__ + "static/img/locked-cc.378e061.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/locked-cc.png
// module id = AJps
// module chunks = 1